module.exports = __webpack_public_path__ + "static/media/icon-claimed.4a0edf3a.svg";